import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Badge,
  Menu,
  MenuItem,
  TextField,
} from '@mui/material';
import {
  Menu as MenuIcon,
  Search,
  Fullscreen,
  Notifications,
  Close,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

interface AppToolbarProps {
  onDrawerToggle: () => void;
  onFullScreen?: () => void;
  title?: string;
}

const AppToolbar: React.FC<AppToolbarProps> = ({
  onDrawerToggle,
  onFullScreen,
  title = 'By Lust Lingerie',
}) => {
  const navigate = useNavigate();
  const [notificationAnchor, setNotificationAnchor] = React.useState<null | HTMLElement>(null);

  const handleNotificationMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setNotificationAnchor(event.currentTarget);
  };

  const handleTitleClick = () => {
    navigate('/dashboard');
  };

  const handleMenuClose = () => {
    setNotificationAnchor(null);
  };

  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
    if (onFullScreen) {
      onFullScreen();
    }
  };

  return (
    <>
      <AppBar position="fixed" color="primary" elevation={1}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={onDrawerToggle}
            edge="start"
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>

          <Typography 
            variant="h6" 
            noWrap 
            component="div" 
            onClick={handleTitleClick}
            sx={{ 
              flexGrow: 0, 
              mr: 3,
              cursor: 'pointer',
              '&:hover': {
                opacity: 0.8,
                textDecoration: 'underline'
              }
            }}
          >
            {title}
          </Typography>

          <Box sx={{ flexGrow: 1, maxWidth: 400, display: { xs: 'none', sm: 'block' } }}>
            <TextField
              fullWidth
              size="small"
              placeholder="Pesquisar..."
              variant="outlined"
              slotProps={{
                input: {
                  startAdornment: <Search sx={{ color: 'white', mr: 1 }} />,
                  sx: {
                    backgroundColor: 'rgba(255, 255, 255, 0.15)',
                    borderRadius: 1,
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'rgba(255, 255, 255, 0.3)',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'rgba(255, 255, 255, 0.5)',
                    },
                    '& input': {
                      color: 'white',
                      '&::placeholder': {
                        color: 'rgba(255, 255, 255, 0.7)',
                      },
                    },
                  },
                },
              }}
            />
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <IconButton color="inherit" onClick={toggleFullScreen}>
              <Fullscreen />
            </IconButton>

            <IconButton color="inherit" onClick={handleNotificationMenuOpen}>
              <Badge badgeContent={3} color="error">
                <Notifications />
              </Badge>
            </IconButton>

          </Box>
        </Toolbar>
      </AppBar>

      {/* Menu de Notificações */}
      <Menu
        anchorEl={notificationAnchor}
        open={Boolean(notificationAnchor)}
        onClose={handleMenuClose}
        sx={{
          '& .MuiPaper-root': {
            elevation: 3,
            mt: 1.5,
            minWidth: 280,
            maxWidth: 400,
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={handleMenuClose}>
          <Box>
            <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
              Nova mensagem de cliente
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Maria Silva enviou uma nova mensagem
            </Typography>
          </Box>
        </MenuItem>
        <MenuItem onClick={handleMenuClose}>
          <Box>
            <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
              Novo pedido recebido
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Pedido #12345 aguardando processamento
            </Typography>
          </Box>
        </MenuItem>
        <MenuItem onClick={handleMenuClose}>
          <Box>
            <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
              Estoque baixo
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Produto XYZ está com estoque baixo
            </Typography>
          </Box>
        </MenuItem>
      </Menu>

    </>
  );
};

export default AppToolbar;
